import { BASE_PATH, LANG } from '../App/constants'

export const STATE_KEY = 'resetPasswordRequest'
export const FORM_RESET_PASSWORD_REQUEST_EMAIL = 'formResetPasswordCheckEmail'
export const RESET_PASSWORD_SEND_EMAIL_PATH = `${BASE_PATH}/${LANG}/resetting/send-email?type=email`

export const CONTENT_LOAD = 'Casino/ResetPasswordRequest/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/ResetPasswordRequest/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/ResetPasswordRequest/LOAD_ERROR'
